<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M53 9h-8.5V6.54a1.5 1.5 0 10-3 0V9h-8V6.54a1.5 1.5 0 10-3 0V9h-8V6.54a1.5 1.5 0 10-3 0V9H11a2 2 0 00-2 2v42a2 2 0 002 2h42a2 2 0 002-2V11a2 2 0 00-2-2zm-33.5 3v3.53a1.5 1.5 0 003 0V12h8v3.53a1.5 1.5 0 003 0V12h8v3.53a1.5 1.5 0 003 0V12H52v9H12v-9zM12 52V24h40v28z"/></svg>